import config from "src/config";
import http from "../services/apiServices";
import { isCivilDefenseUser } from "src/utils/helpers";

export const getBMCWithRatingApi = async (data: any) => {
  const api = config.BMCCompany.getBMCWithRating;
  return await http.post(api, data);
};
export const sendRequestToBMCApi = async (data: any) => {
  return await http.post(config.CivilDefense.sendRequestToBMC, data);
};
